export default "__VITE_ASSET__B27LPGW___"